"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HeaderImageTitleCenter;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Skew = _interopRequireDefault(require("./Skew.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// components
function HeaderImageTitleCenter(_ref) {
  var bgImage = _ref.bgImage,
      title = _ref.title,
      description = _ref.description,
      skewColor = _ref.skewColor;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "absolute top-0 w-full h-full bg-center bg-cover",
    style: {
      backgroundImage: "url('" + bgImage + "')"
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "w-full h-full absolute opacity-75 bg-black"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "container relative mx-auto"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "items-center flex flex-wrap"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full lg:w-7/12 px-4 ml-auto mr-auto text-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: ""
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "text-white font-semibold text-5xl"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "mt-4 text-lg text-blueGray-300"
  }, description))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full absolute top-auto bottom-0"
  }, /*#__PURE__*/_react.default.createElement(_Skew.default, {
    color: skewColor
  }))));
}

HeaderImageTitleCenter.defaultProps = {
  skewColor: "blueGray"
};
HeaderImageTitleCenter.propTypes = {
  bgImage: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  description: _propTypes.default.string.isRequired,
  skewColor: _propTypes.default.oneOf(["blueGray", "red", "orange", "amber", "emerald", "teal", "lightBlue", "indigo", "purple", "pink"])
};
